/**
 * Header — top navigation bar.
 */

import { Logo } from "./Logo";
import { ConnectButton } from "./ConnectButton";
import { ThemeToggle } from "./ThemeToggle";

export function Header() {
  return (
    <header className="sticky top-0 z-10 border-b border-[--border] bg-[--bg]/80 backdrop-blur-md">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4 sm:px-6">
        <a
          href="/"
          className="flex items-center gap-2.5 text-[--text] no-underline"
        >
          <Logo />
          <div className="flex flex-col leading-none">
            <span className="text-[15px] font-semibold tracking-tight">
              asicrouter
            </span>
            <span className="text-[10px] uppercase tracking-[0.12em] text-[--text-subtle]">
              ASIC aggregator
            </span>
          </div>
        </a>
        <nav aria-label="Header actions" className="flex items-center gap-2">
          <ConnectButton />
          <ThemeToggle />
        </nav>
      </div>
    </header>
  );
}
